import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicModule } from 'ng-dynamic-component';
import { ButtonModule, DialogModule } from '@lockton-apps/shared/ui/lui';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormDialogCloseResult, FormDialogData } from './form-dialog-data';
import { MatIconModule } from '@angular/material/icon';
import { DynamicFormsModule } from '@lockton-apps/dynamic-forms';
import { cloneDeep } from 'lodash';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'la-form-dialog',
    imports: [
        CommonModule,
        DialogModule,
        DynamicModule,
        MatIconModule,
        ButtonModule,
        DynamicFormsModule,
        ReactiveFormsModule,
    ],
    templateUrl: './form-dialog.component.html',
    styleUrls: ['./form-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormDialogComponent implements OnInit {
  form = new FormGroup({});

  model!: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: FormDialogData,
    private dialogRef: MatDialogRef<
      FormDialogComponent,
      FormDialogCloseResult | undefined
    >
  ) {
    this.model = data.model ? cloneDeep(data.model) : {};
  }

  async ngOnInit(): Promise<void> {
    // TODO: below is temp workaround for the bug:
    // Comment out below and: open dialog -> dirty the form so the error messages shows -> close dialog -> open again
    // When it's re-opened, the error messages are still visible, but they shouldn't.
    await firstValueFrom(this.dialogRef.afterClosed());
    this.form.reset();
  }

  confirm() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close({ model: this.model, mode: this.data.mode });
  }

  cancel() {
    this.dialogRef.close();
  }
}
